import { useQuery } from "react-query";
import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import axios from "infra/http";
import { FeriadoResponsePaginate } from "../typings";

function useFeriados(tenantId?: string, filtro?: PaginateQuery) {
  return useQuery(["/v1/feriado", filtro], async () => {

    const headers = { tenant: tenantId ?? null };

    const { data } = await axios.get<PaginateResult<FeriadoResponsePaginate>>(
      "/v1/feriado",
      {
        params: { ...filtro, tenantId },
        headers
      }
    );

    return data;
  });
}

export default useFeriados;
